import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import VwReferansDoktorDTO from "src/models/GenelTanimlar/VwReferansDoktorDTO";
import { GridState } from "src/models/GridState";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import ReferansDoktorService from "src/services/geneltanimlar/ReferansDoktorService";

export interface IReferansDoktorState extends GridState<VwReferansDoktorDTO> {
    pasifGosterme: boolean
}

export const createUpdate = createAsyncThunk(
    'ReferansDoktorService/createUpdate',
    async (data: VwReferansDoktorDTO, thunkAPI) => {
        const response = await ReferansDoktorService.createUpdate(data);
        return response
    }
)
export const getReferansDoktor = createAsyncThunk(
    'ReferansDoktorService/getReferansDoktor',
    async (pasifGosterme: boolean, thunkAPI) => {
        const response = await ReferansDoktorService.getReferansDoktor(pasifGosterme);
        return response
    }
)
export const deleteRecord = createAsyncThunk(
    'ReferansDoktorService/deleteRecord',
    async (id: number) => {
        const response = await ReferansDoktorService.deleteRecord(id);
        return response;
    }
)

const ReferansDoktorSlice = createSlice<IReferansDoktorState, MapReducerPayloads<IReferansDoktorState, {
    setState: IReferansDoktorState,
}>>({
    name: 'ReferansDoktorState',
    initialState: {
        data: [],
        activeRow: new VwReferansDoktorDTO(),
        isFetching: true,
        pasifGosterme: true
    },
    reducers: {
        setState: (state, action) => action.payload
    },
    extraReducers: (builder) => {
        builder.addCase(createUpdate.pending, (state, { payload }) => {
            state.isLoading = true
        })
        builder.addCase(createUpdate.fulfilled, (state, action) => {
            return {
                ...state,
                activeRow: action.payload.responseCode !== 200 ? state.activeRow : action.payload.data,
                errorMessage: action.payload.errorMessage,
                isLoading: false,
            }
        })
        builder.addCase(getReferansDoktor.pending, (state, { payload }) => {
            state.isLoading = true
        })
        builder.addCase(getReferansDoktor.fulfilled, (state, action) => {
            return {
                ...state,
                data: action.payload.data || [],
                errorMessage: action.payload.errorMessage,
                isLoading: false,
                isFetching: false
            }
        })
    }

})
export default ReferansDoktorSlice;